import React, {useCallback, useEffect} from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import URL from '../constants/url';
import PATH from '../constants/url';

import PageError from '../components/comm/PageError';
import { onNativeMessage } from '../bridge/nativeBridge';
import MessageTypes from '../bridge/messageTypes';

// 로그인
import AllowAccess from '../pages/user/login/AllowAccess';  // 앱 접근 권한 허용
import Landing from '../pages/user/login/Landing';
import LoginMain from '../pages/user/login/LoginMain';
import PrescriptionCode from '../pages/user/login/PrescriptionCode';
import FindId from '../pages/user/login/membership/FindId';
import FindPassword from '../pages/user/login/membership/FindPassword';
import Identity from '../pages/user/login/identity/Identity';  // 본인 확인 방법
import SignUp from '../pages/user/login/membership/SignUp';  // 회원 가입
import AgreeConditions from '../pages/user/login/membership/AgreeConditions';  // 약관 동의
import MembershipComplete from '../pages/user/login/membership/MembershipComplete';  // 회원가입 완료
import ActivityLevelSelect from '../pages/user/login/ActivityLevelSelect';   // 활동량 선택

import MembershipFailed from '../pages/user/login/membership/MembershipFailed';  // 회원가입 완료

//알림
import Alarm from '../pages/user/alarm/Alarm';

//설정
import AppSettings from '../pages/user/appsetting/AppSettings';
import MyInfoWrite from '../pages/user/appsetting/MyInfoWrite';  // 앱 설정 > 내 정보 수정
import ChangePassword from '../pages/user/appsetting/ChangePassword';  // 앱 설정 > 내 정보 수정 > 비밀번호 변경
import MyInfoWithdraw from '../pages/user/appsetting/MyInfoWithdraw';  // 앱 설정 > 내 정보 수정 > 탈퇴하기
import ServicePolicy from '../pages/user/appsetting/ServicePolicy';  // 앱 설정 > 서비스 약관 및 정책
import ServicePolicyDetail from '../pages/user/appsetting/ServicePolicyDetail';  // 앱 설정 > 서비스 약관 및 정책 > 상세보기
import AppVersion from '../pages/user/appsetting/AppVersion';  // 앱 설정 > 앱 버전 정보
import AlarmIntensity from '../pages/user/appsetting/AlarmIntensity';  // 앱 설정 > 알림 강도 설정
import ActivityLevelChange from '../pages/user/appsetting/ActivityLevelChange';  // 앱 설정 > 신체 활동량 변경


//홈
import HomeMain from '../pages/user/home/HomeMain';

//식단 관리
import FoodRecordMain from '../pages/user/home/food/FoodRecordMain';
import FoodRecordDetail from '../pages/user/home/food/FoodRecordDetail';
import PhotoCapture from '../pages/user/home/food/PhotoCapture';
import FoodItemDetail from '../pages/user/home/food/FoodItemDetail';
import FoodSearch from '../pages/user/home/food/FoodSearch';
import FoodManualAdd from '../pages/user/home/food/FoodManualAdd';


//운동 기록
import ExerciseRecordMain from '../pages/user/home/exercise/ExerciseRecordMain';
import ExerciseRecordAdd from '../pages/user/home/exercise/ExerciseRecordAdd';
import ExerciseRecordComplete from '../pages/user/home/exercise/ExerciseRecordComplete';

//걸음수 기록
import StepsMain from '../pages/user/home/steps/StepsMain';  // 걸음수 기록 메인
import StepsDashboard from '../pages/user/home/steps/StepsDashboard';  // 걸음수 대시보드
import StepsRecordList from '../pages/user/home/steps/StepsRecordList';  // 걸음수 기록 리스트

//혈압 기록
import BloodPressureRecord from '../pages/user/home/bloodpressure/BloodPressureRecord';  // 혈압기록
import BloodPressureWrite from '../pages/user/home/bloodpressure/BloodPressureWrite';  // 혈압기록하기
import WatchBpGuide from '../pages/user/home/bloodpressure/WatchBpGuide';

//체질량 기록
import BodyMassRecord from '../pages/user/home/bodymass/BodyMassRecord';  // 체질량 기록
import BodyMassWrite from '../pages/user/home/bodymass/BodyMassWrite';  // 체질량 기록하기

//검사결과
import HealthResultsMain from '../pages/user/healthresult/HealthResultsMain';

//리포트
import ReportMain from '../pages/user/report/ReportMain';

//건강정보
import HealthInfoMain from '../pages/user/healthinfo/HealthInfoMain';
import HealthInfoDetail from '../pages/user/healthinfo/HealthInfoDetail';

import KakaoRedirectPage from "../pages/user/login/callback/KakaoRedirectPage";
import NaverRedirectPage from "../pages/user/login/callback/NaverRedirectPage";
import GoogleRedirectPage from "../pages/user/login/callback/GoogleRedirectPage";
import AppleRedirectPage from "../pages/user/login/callback/AppleRedirectPage";
import NiceRedirectPage from "../pages/user/login/callback/NiceRedirectPage";
import NiceDpRedirectPage from "../pages/user/login/callback/NiceDpRedirectPage";

//챗
import DietChatBot from '../pages/user/chatbot/DietChatBot';
import ExerciseChatBot from '../pages/user/chatbot/ExerciseChatBot';
import ServiceChat from '../pages/user/chatbot/ServiceChat';

const ScrollToTop = () => {

    const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);

        return null;
    };





/* 같은 알림이 한 번 더 넘어올 때 또 이동하지 않게 막는다 */
const PUSH_HANDLED_KEY = 'iitp.push.handled';
const PUSH_HANDLED_MAX = 20;

const readHandledPush = () => {
    try {
        return JSON.parse(localStorage.getItem(PUSH_HANDLED_KEY)) || [];
    } catch {
        return [];
    }
};

const isHandledPush = (pushId) => !!pushId && readHandledPush().includes(pushId);

const markHandledPush = (pushId) => {
    if (!pushId) return;
    const next = [...readHandledPush().filter((id) => id !== pushId), pushId]
        .slice(-PUSH_HANDLED_MAX);
    localStorage.setItem(PUSH_HANDLED_KEY, JSON.stringify(next));
};

/*
 * 로그인 전에 받은 경로. 401 이 나면 daonAxios 가 location.href 로 페이지를 통째로 새로 띄우므로
 * 메모리에 들고 있으면 조용히 날아간다. 묵은 건은 다른 계정이 쓸 수 있어 10분만 유효하다.
 */
const PUSH_PENDING_KEY = 'iitp.push.pending';
const PUSH_PENDING_TTL = 10 * 60 * 1000;

const clearPendingPush = () => localStorage.removeItem(PUSH_PENDING_KEY);

const readPendingPush = () => {
    let saved;
    try {
        saved = JSON.parse(localStorage.getItem(PUSH_PENDING_KEY));
    } catch {
        clearPendingPush();
        return null;
    }
    if (!saved?.targetRoute) return null;
    if (Date.now() - (saved.at ?? 0) > PUSH_PENDING_TTL) {
        clearPendingPush();
        return null;
    }
    return saved;
};

const writePendingPush = (payload) =>
    localStorage.setItem(PUSH_PENDING_KEY, JSON.stringify({ ...payload, at: Date.now() }));


/**
 * OS 알림 탭 → 이동. 경로 규칙은 알림함(Alarm.jsx)과 같다.
 * 로그인 전이면 들고 있다가 홈에 도착하면 보낸다 (라우트에 인증 가드가 없다).
 */
const PushNavigator = () => {

    const navigate = useNavigate();
    const { pathname } = useLocation();

    const isSignedIn = () => !!localStorage.getItem('jToken');

    const go = useCallback((payload) => {
        const route = payload?.targetRoute;
        if (!route || isHandledPush(payload.pushId)) return;
        if (!isSignedIn()) {
            writePendingPush(payload);
            return;
        }
        markHandledPush(payload.pushId);
        navigate(route);
    }, [navigate]);

    useEffect(
        () =>
            onNativeMessage((msg) => {
                if (msg.type !== MessageTypes.PUSH_NAVIGATE) return;
                go(msg.payload);
            }),
        [go],
    );

    // 로그인 후 홈에 도착하면 보류분 실행
    useEffect(() => {
        if (pathname !== URL.HOME_MAIN || !isSignedIn()) return;
        const payload = readPendingPush();
        if (!payload) return;
        clearPendingPush();
        markHandledPush(payload.pushId);
        navigate(payload.targetRoute);
    }, [pathname, navigate]);

    return null;
};


const RootRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <PushNavigator />
      <Routes>
        <Route path={URL.MAIN} element={<Landing />} />

        <Route path={URL.ERROR} element={<PageError />} />


        {/* SNS 로그인 Redirect 처리 페이지 */}
        <Route path={URL.KAKAO_REDIRECT} element={<KakaoRedirectPage />} />
        <Route path={URL.NAVER_REDIRECT} element={<NaverRedirectPage />} />
        <Route path={URL.GOOGLE_REDIRECT} element={<GoogleRedirectPage />} />
        <Route path={URL.APPLE_REDIRECT} element={<AppleRedirectPage />} />

        {/* 나이스 리다이렉트 */}
        <Route path={URL.NICE_REDIRECT} element={<NiceRedirectPage />} />
        <Route path={URL.NICE_DPREDIRECT} element={<NiceDpRedirectPage />} />

        {/* 로그인 영역 */}
        <Route path={URL.ALLOW_ACCESS} element={<AllowAccess />} />
        <Route path={URL.LANDING} element={<Landing />} />
        <Route path={URL.LOGIN_MAIN} element={<LoginMain />} />
        <Route path={URL.PRESCRIPTION_CODE} element={<PrescriptionCode />} />
        <Route path={URL.FIND_ID} element={<FindId />} />
        <Route path={URL.FIND_PASSWORD} element={<FindPassword />} />

        <Route path={URL.IDENTITY} element={<Identity />} />
        <Route path={URL.SIGN_UP} element={<SignUp />} />

        <Route path={URL.AGREE_CONDITIONS} element={<AgreeConditions />} />
        <Route path={URL.MEMBERSHIP_COMPLETE} element={<MembershipComplete />} />
        <Route path={URL.ACTIVITY_LEVEL_SELECT} element={<ActivityLevelSelect />} />

        <Route path={URL.MEMBERSHIP_FAILED} element={<MembershipFailed />} />

        {/* 알림 */}
        <Route path={URL.ALARM} element={<Alarm />} />

        {/* 앱 설정 */}
        <Route path={URL.APP_SETTINGS} element={<AppSettings />} />
        <Route path={URL.MYINFO_WRITE} element={<MyInfoWrite />} />
        <Route path={URL.CHANGE_PASSWORD} element={<ChangePassword />} />
        <Route path={URL.MY_INFO_WITHDRAW} element={<MyInfoWithdraw />} />
        <Route path={URL.SERVICE_POLICY} element={<ServicePolicy />} />
        <Route path={URL.SERVICE_POLICY_DETAIL} element={<ServicePolicyDetail />} />
        <Route path={URL.APP_VERSION} element={<AppVersion />} />
        <Route path={URL.ALARM_INTENSITY} element={<AlarmIntensity />} />
        <Route path={URL.ACTIVITY_LEVEL_CHANGE} element={<ActivityLevelChange />} />

        {/* 홈 */}
        <Route path={URL.HOME_MAIN} element={<HomeMain />} />

          {/* 식단 관리 */}
          <Route path={URL.FOOD_RECORD_MAIN} element={<FoodRecordMain />} />
          <Route path={URL.FOOD_RECORD_DETAIL} element={<FoodRecordDetail />} />
          <Route path={URL.FOOD_PHOTO_CAPTURE} element={<PhotoCapture />} />
          <Route path={URL.FOOD_ITEM_DETAIL} element={<FoodItemDetail />} />
          <Route path={URL.FOOD_SEARCH} element={<FoodSearch />} />
          <Route path={URL.FOOD_MANUAL_ADD} element={<FoodManualAdd />} />

          {/* 운동 관리 */}
          <Route path={URL.EXERCISE_RECORD_MAIN} element={<ExerciseRecordMain />} />
          <Route path={URL.EXERCISE_RECORD_ADD} element={<ExerciseRecordAdd />} />
          <Route path={URL.EXERCISE_RECORD_COMPLETE} element={<ExerciseRecordComplete />} />

          {/* 걸음수 기록 */}
          <Route path={URL.STEPS_MAIN} element={<StepsMain />} />
          <Route path={URL.STEPS_DASHBOARD} element={<StepsDashboard />} />
          <Route path={URL.STEPS_RECORD_LIST} element={<StepsRecordList />} />

          {/* 혈압 기록 */}
          <Route path={URL.BLOOD_PRESSURE_RECORD} element={<BloodPressureRecord />} />
          <Route path={URL.BLOOD_PRESSURE_WRITE} element={<BloodPressureWrite />} />
          <Route path={URL.WATCH_BP_GUIDE} element={<WatchBpGuide />} />

          {/* 체질량 기록 */}
          <Route path={URL.BODY_MASS_RECORD} element={<BodyMassRecord />} />
          <Route path={URL.BODY_MASS_WRITE} element={<BodyMassWrite />} />

        {/* 검사 결과 */}
        <Route path={URL.HEALTH_RESULTS} element={<HealthResultsMain />} />

        {/* 리포트 */}
        <Route path={URL.REPORT} element={<ReportMain />} />

        {/* 건강 정보 */}
        <Route path={URL.HEALTH_INFORM} element={<HealthInfoMain />} />
        <Route path={URL.HEALTH_INFORM_DETAIL} element={<HealthInfoDetail />} />

        {/* 챗봇 */}
        <Route path={URL.DIET_CHATBOT} element={<DietChatBot />} />
        <Route path={URL.EXERCISE_CHATBOT} element={<ExerciseChatBot />} />
        <Route path={URL.CHATBOT} element={<ServiceChat />} />

        {/* 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>  
  );
};

// 아직 구현 안 된 페이지용 placeholder
const PlaceholderPage = ({ title }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="header header-sub">
        <div className='left' onClick={() => navigate(-1)}>
          <button><span className='blind'>뒤로가기</span></button>
          <h3>{title}</h3>
        </div>
      </div>
      <div id="sub-content" data-layout="white">
        <div className='inner-wrap' data-pad="normal">
          <div style={{ textAlign: 'center', padding: '8rem 2rem', color: '#999' }}>
            <p style={{ fontSize: '1.8rem', fontWeight: 600 }}>{title}</p>
            <p style={{ fontSize: '1.4rem', marginTop: '0.8rem' }}>준비중입니다.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default RootRoutes;
